import { FormGroup } from "@mui/material";
import { useMarketplaceStore } from "../../../../../../store/useMarketplaceStore";
import { Percent } from "@mui/icons-material";
import { IntegerRangeFilter } from "../../../../../../components/dataGridFilter/filter-components/IntegerRangeFilter";

const filters = [
  {
    name: "marketplaceProduct.marketplaceSummary.mainCategorySalesRank",
    labelKey:
      "pages.inventoryManagement.inventory.list.filters.filterGroup6.mainCategorySalesRank",
  },
  {
    name: "marketplaceProduct.marketplaceSummary.subCategorySalesRank",
    labelKey:
      "pages.inventoryManagement.inventory.list.filters.filterGroup6.subCategorySalesRank",
  },
  {
    name: "marketplaceProduct.marketplaceSummary.totalOfferCount",
    labelKey:
      "pages.inventoryManagement.inventory.list.filters.filterGroup6.totalOfferCount",
  },
  {
    name: "marketplaceProduct.marketplaceSummary.buyBoxEligibleOfferCount",
    labelKey:
      "pages.inventoryManagement.inventory.list.filters.filterGroup6.buyBoxEligibleOfferCount",
  },
  {
    name: "priceDifferencesWithBuyBox",
    labelKey:
      "pages.inventoryManagement.inventory.list.filters.filterGroup6.priceDifferencesWithBuyBox",
    adornment: <Percent fontSize="small" />,
    suffix: "%",
  },
  {
    name: "priceDifferencesWithLowest",
    labelKey:
      "pages.inventoryManagement.inventory.list.filters.filterGroup6.priceDifferencesWithLowest",
    adornment: <Percent fontSize="small" />,
    suffix: "%",
  },
  {
    name: "competitiveBuyBoxMarginPercentage",
    labelKey:
      "pages.inventoryManagement.inventory.list.filters.filterGroup6.profitPercentageDifferencesWithBuyBox",
    adornment: <Percent fontSize="small" />,
    suffix: "%",
  },
  {
    name: "competitiveMinMarginPercentage",
    labelKey:
      "pages.inventoryManagement.inventory.list.filters.filterGroup6.profitPercentageDifferencesWithLowest",
    adornment: <Percent fontSize="small" />,
    suffix: "%",
  },
];

export const FilterGroup6 = () => {
  const selectedCountry = useMarketplaceStore((state) => state.selectedCountry);

  return (
    <FormGroup
      sx={{
        bgcolor: "customBackground.box",
        borderRadius: 1,
        mb: 2,
        padding: 2,
        display: "flex",
        gap: 2,
      }}
    >
      {filters.map(({ name, labelKey, adornment, suffix }) => (
        <IntegerRangeFilter
          key={name}
          name={name}
          labelKey={labelKey}
          labelVars={{
            market: selectedCountry?.countryName ?? "",
          }}
          adornment={adornment}
          labelSuffix={suffix}
        />
      ))}
    </FormGroup>
  );
};
